/**
 * This file defines the getLocalNavigationItems function, which is responsible for generating
 * the navigation items for the local Help pages in the application.
 *
 * The function takes the locale as a parameter and returns an array of navigation items.
 * Each navigation item is an object that contains the tab name, title, URL, and icon class name.
 *
 * The URLs for the shipping returns, privacy policy, terms and conditions, and contact us pages are generated using the constants from 'hah-fe-core'.
 * The URLs for the terms of use page are hardcoded for each locale.
 *
 * The titles for the navigation items are translation keys that can be used with the 'next-i18next' library to get the translated titles.
 *
 * The icon class names for the navigation items are class names that can be used with the icon library to display the icons for the navigation items.
 *
 * If you need to add any additional constants for the Help pages that will only be used for this site, you can do so here.
 */

import {
  SHIPPING_RETURNS,
  PRIVACY_POLICY,
  TERMS_AND_CONDITIONS,
  CONTACT_US,
} from '@Hotels-at-Home/hah-fe-core/dist/constants';

export const getLocalNavigationItems = (locale: string) => [
  {
    tabName: 'shipping-returns',
    title: '$common.$labels.shippingAndReturns',
    url: `/${locale}${SHIPPING_RETURNS}`,
    iconClassName: 'icon-truck',
  },
  {
    tabName: 'privacy-policy',
    title: '$common.$labels.privacyPolicy',
    url: `/${locale}${PRIVACY_POLICY}`,
    iconClassName: 'icon-padlock',
  },
  {
    tabName: 'terms-of-use',
    title: '$common.$labels.termsOfUse',
    // TODO: Move below URLs to CMS
    url: {
      en: 'https://www.marriott.co.uk/about/terms-of-use.mi',
      fr: 'https://www.marriott.fr/about/terms-of-use.mi',
      de: 'https://www.marriott.de/about/terms-of-use.mi',
      es: 'https://www.espanol.marriott.com/about/terms-of-use.mi',
    },
    iconClassName: 'icon-gavel',
  },
  {
    tabName: 'terms-and-conditions',
    title: '$common.$labels.termsAndConditions',
    url: `/${locale}${TERMS_AND_CONDITIONS}`,
    iconClassName: 'icon-scroll',
  },
  {
    tabName: 'contact-us',
    title: '$common.$labels.contactUs',
    url: `/${locale}${CONTACT_US}`,
    iconClassName: 'icon-envelope',
  },
];

export default getLocalNavigationItems;
